export const FIELD_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  EMAIL: 'email',
  TEXTAREA: 'textarea',
  SELECT: 'select',
  CUSTOM: 'custom',
};

export const DEFAULT_FIELD_GRID = { xs: 12 };
